/**
 * Object containing default libraries for the VEF.
 * @memberof vef.defaults
 */
const LIBRARIES = {
    Photoswipe: {
        js: 'lib/photoswipe/5.3.3/photoswipe.esm.min.js',
        css: ['lib/photoswipe/5.3.3/photoswipe.css']
    },
    PhotoSwipeDynamicCaption: {
        js: 'lib/photoswipe-dynamic-caption-plugin/1.2.7/photoswipe-dynamic-caption-plugin.esm.js',
        css: ['lib/photoswipe-dynamic-caption-plugin/1.2.7/photoswipe-dynamic-caption-plugin.css']
    },
    JSONEditor: {
        js: "lib/json-editor/2.14.0/jsoneditor.min.js",
        global: "JSONEditor"
    },
    html2canvas: {
        js: 'lib/html2canvas/1.4.1/html2canvas.min.js',
        global: "html2canvas"
    },
    PhotoswipeLightbox: 'lib/photoswipe/5.3.3/photoswipe-lightbox.esm.min.js',
    lazysizes: 'lib/lazysizes/5.3.1/lazysizes.min.js'
};

export { LIBRARIES };